<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.discounts') }} > {{ this.$route.query.discount_name }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="discount !== null"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section class="choose-type">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.selecttype')"/>
            <div class="row wrapper">
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.discount_type"
                    :disabled="disabledForm"
                    color="#A3CA76"
                    vsValue="general"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.discountgeneral') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.discountgeneraldetail') }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-12 row no-margin no-padding">
                  <vs-radio
                    v-model="form.discount_type"
                    :disabled="disabledForm"
                    color="#A3CA76"
                    vsValue="conditional"
                    style="float: left;padding: 0;">
                    <strong>{{ $t('message.discountcondition') }}</strong>
                  </vs-radio>
                </div>
                <div
                  class="form-check-label"
                  style="margin-left: 25px;">
                  <p>{{ $t('message.discountconditiondetail') }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.general')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.discount_name') }} *</label>
                    <input
                      ref="discount_name"
                      :class="[class_.discount_name]"
                      :disabled="disabledForm"
                      v-model="form.discount_name"
                      type="text"
                      class="form-control discount-name"
                      @keyup="onKeyUpDiscountName">
                  </div>
                </div>
              </div>
              <div
                v-if="form.discount_type === 'general'"
                class="col">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.discount_amount') }} *</label>
                    <div class="input-group">
                      <input
                        ref="amount"
                        :class="[class_.amount]"
                        :disabled="disabledForm"
                        v-model="form.amount"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        style="border-right: 0;"
                        @keypress="numberOnly"
                        @keyup="form.amount = setToValidNumber(form.amount)"
                        @blur="form.amount = setToCustomDigitsNumber(form.amount)">
                      <div class="input-group-prepend">
                        <button
                          class="btn dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style="border: 1px solid #ced4da;">
                          <template v-if="form.type == 'percentage'">
                            %
                          </template>
                          <template v-if="form.type == 'number'">
                            {{ currency }}
                          </template>
                        </button>
                        <div class="dropdown-menu">
                          <a
                            class="dropdown-item"
                            @click="form.type = 'percentage'">%</a>
                          <a
                            class="dropdown-item"
                            @click="form.type = 'number'">{{ currency }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="form.discount_type === 'conditional'"
              class="form-row mt-2">
              <div class="col-md-12">
                <label>{{ $t('message.discount_amount') }} *</label>
                <div class="form-group row mb-0 no-margin">
                  <DiscountCondition
                    v-model="conditions"
                    :disabled="disabledForm"
                    page="edit"/>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="items.length > 0"
          :class="[{ disabled: disabledForm }]"
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems') + ' ('+assignitems.length+')'"/>
            <div class="col-md-12 row align-items-center no-padding no-margin subheader-assign">
              <div class="col no-padding">{{ $t('message.productlist') }}</div>
            </div>
            <div
              v-for="(item, index) in items"
              :key="index"
              :class="{ active: item.active}"
              class="col-md-12 row align-items-center no-padding no-margin item"
              @click="toggleAssign(item)">
              <div class="col">
                {{ item.product_name }}
              </div>
              <div class="col text-right">
                <span
                  v-for="(_item, index) in item.discounts"
                  v-if="_item.discount_id != discount.discount_id"
                  :key="index"
                  class="comma">
                  {{ _item.discount_name }}
                </span>
                <span v-if="item.active">
                  {{ form.discount_name }}
                </span>
                <i class="fas fa-check-circle"/>
                <i class="far fa-circle"/>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="!disabledForm"
          class="action-bar"
        >
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="update()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5
              v-if="discount"
              class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import DiscountCondition from '@/components/custom/DiscountCondition.vue'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'DiscountEdit',

  components: {
    DiscountCondition,
  },

  mixins: [discardFormMixin, userPermissionMixin],

  data () {
    return {
      ready: false,

      form: {
        discount_name: '',
        discount_type: 'general',
        amount: '0',
        type: 'percentage',
      },
      original_textfield: null,

      items: [],
      original_items: null,

      assignitems: [],
      original_assignitems: null,

      class_: {
        discount_name: null,
        amount: null,
      },

      conditions: [],

      isSubmitted: false,
    }
  },
  computed: Object.assign(mapGetters({
    sidebar: 'getSidebar',
    products: 'getProducts',
    discount: 'getDiscount',
    currency: 'getCurrency',
  }), {
    dataDiscount () {
      let data = {
        discount_id: this.discount.discount_id,
        discount_name: this.form.discount_name,
      }

      if (this.form.discount_type === 'general') {
        data['type'] = 'general'
        data['value_type'] = this.form.type
        data['value_amount'] = parseFloat(this.form.amount)
      } else {
        data['type'] = 'conditional'
        data['conditions'] = this.filterConditions
      }

      if (this.assignitems.length > 0) {
        data['assign'] = this.assignitems
      }
      return data
    },
    IsValidform () {
      if (this.form.discount_name.trim().length == 0) {
        this.class_.discount_name = 'is-invalid'
        this.$refs.discount_name.focus()
      }
      return this.class_.discount_name == null && this.class_.amount == null
    },
    filterConditions () {
      return this.conditions.filter((item) => {
        if (item.quantity === null || item.value_amount === null) {
          return false
        }
        return true
      })
        .map((item) => {
          return {
            ...item,
            quantity: parseFloat(item.quantity),
            value_amount: parseFloat(item.value_amount),
          }
        })
    },
    disabledForm () {
      return !this.hasRoleEdit
    },
  }),
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    items: {
      handler: function (after) {
        let items = after
        this.updateAssignItems(items)
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    /**
     *  validation
     */
    if (!this.$route.query.discount_id) {
      return this.$router.push({ name: 'DiscountAll' })
    }
    // get discount
    let res = await this.$store.dispatch('getDiscount', {
      discount_id: this.$route.query.discount_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'DiscountAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'DiscountAll' })
    }
    /**
     *  validation success
     */
    // set textfield discount_name
    this.form.discount_name = this.discount.discount_name
    this.form.discount_type = this.discount.type

    if (this.discount.type === 'general') {
      this.form.type = this.discount.value_type
      this.form.amount = this.setToCustomDigitsNumber(this.discount.value_amount.toString())
    } else {
      this.conditions = _.cloneDeep(this.discount.conditions).map((condi) => {
        return {
          ...condi,
          quantity: this.setToCustomDigitsNumber(condi.quantity),
          value_amount: this.setToCustomDigitsNumber(condi.value_amount),
        }
      })
    }

    // get products
    await this.$store.dispatch('getProducts')
    // set items
    this.setItems(this.discount, this.products)
    // update assignitems
    this.updateAssignItems(this.items)
    // original textfield
    this.original_textfield = this.getObject(this.form)
    // original items
    this.original_items = this.getObject(this.items)
    // original assignitems
    this.original_assignitems = this.getObject(this.assignitems)
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 2, [{
      'name': this.$route.query.discount_name,
      'router': {
        'name': 'DiscountEdit',
        'query': {
          discount_id: this.$route.query.discount_id,
          discount_name: this.$route.query.discount_name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 2,
      submenuAtIdx: 2,
    })
  },
  mounted: function () { // run script
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts', 'clearDiscount'])
  },
  methods: {
    async update () {
      this.isSubmitted = true

      if (!this.IsValidform) {
        return false
      }

      let res = await this.$store.dispatch('updateDiscount', this.dataDiscount)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.form.discount_name }),
          color: 'success',
          icon: 'save',
        })
        // get products
        await this.$store.dispatch('getProducts')
        // set items
        this.setItems(this.discount, this.products)
        // update assignitems
        this.updateAssignItems(this.items)
        // original textfield
        this.original_textfield = this.getObject(this.form)
        // original items
        this.original_items = this.getObject(this.items)
        // original assignitems
        this.original_assignitems = this.getObject(this.assignitems)
        // set condition
        this.conditions = this.conditions.filter((item) => {
          if (item.quantity === null || item.value_amount === null) {
            return false
          }
          return true
        })
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    async del () {
      let data = {
        discount_id: this.discount.discount_id,
      }

      let res = await this.$store.dispatch('deleteDiscount', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.form.discount_name }),
          color: 'danger',
          icon: 'delete',
        })
        // close modal
        this.closeConfirmdeleteModal()
        // go to GoodsIssueAll page
        return this.$router.push({ name: 'DiscountAll' })
      }
    },
    toggleAssign (item) {
      if (this.form.discount_name.trim().length == 0) {
        return
      }
      item.active = !item.active
    },
    setItems (discount, products) {
      this.items = []
      for (let i in products) {
        let product = products[i]
        if (product.type == 'product') {
          var active = false
          if (discount) {
            for (let j in product.discounts) {
              let item = product.discounts[j]
              if (discount.discount_id == item.discount_id) {
                active = true
              }
            }
          }
          this.items.push({
            product_id: product.product_id,
            product_name: product.product_name,
            discounts: product.discounts,
            active: active,
          })
        }
      }
    },
    updateAssignItems (items) {
      this.assignitems = []
      for (let i in items) {
        let item = items[i]
        if (item.active) {
          this.assignitems.push({
            product_id: item.product_id,
          })
        }
      }
    },
    openConfirmdeleteModal () {
      // open modal
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    onKeyUpDiscountName () {
      if (this.form.discount_name.trim().length > 0) {
        this.class_.discount_name = null
      } else {
        this.class_.discount_name = 'is-invalid'
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/discount/Edit.vue